import moment from 'moment'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import GridTable from '../../common/GridTable/GridTable'
import Loader from '../../common/loader/Loader'
import { ReactComponent as MailIcon } from '../../../assets/images/common/icons/mail-icon.svg'

import classes from './InvitedTable.module.scss'

const COLUMN_WIDTH = 'minmax(160px, 1fr)'

const InvitedTable = ({ students, onResendInvite }) => {
  const { t } = useTranslation()

  if (!students) {
    return (
      <div className='h-100 d-flex align-items-center justify-content-center'>
        <Loader>{t('members.loading.invitations')}</Loader>
      </div>
    )
  }

  const firstColumn = {
    width: '320px',
    header: t('members.studentsCountHeading', { count: students.length }),
    render: (student) => (
      <p className='font-weight-bold m-0' title={`${student.firstName} ${student.lastName}`}>{student.firstName} {student.lastName}</p>
    ),
  }

  const columns = [
    {
      key: 'invitedOn', gridWidth: COLUMN_WIDTH, align: 'center', header: t('members.invitedTable.columns.invitedOn'),
      render: (student) => <span className='font-weight-bold'>{student.createdAt ? moment(student.createdAt).format('DD/MM/YYYY') : '-'}</span>,
    },
    {
      key: 'email', gridWidth: COLUMN_WIDTH, align: 'center', header: t('common.field.email'),
      render: (student) => student.email || '',
    },
    {
      key: 'invitedBy', gridWidth: COLUMN_WIDTH, align: 'center', header: t('members.invitedTable.columns.invitedBy'),
      render: (student) => (
        <span className='font-weight-bold'>{student.inviter ? `${student.inviter.firstName} ${student.inviter.lastName}` : '-'}</span>
      ),
    },
    {
      key: 'resendInvite', gridWidth: 'max-content', align: 'center', header: t('members.invitedTable.columns.resendInvite'),
      render: (student) => (
        <button className={classes.resendInviteButton} onClick={() => onResendInvite(student.id)}>
          <MailIcon className={classes.contactIcon} />
          {t('members.invitedTable.columns.resendInvite')}
        </button>
      ),
    },
  ]

  return (
    <GridTable
      id='invitedTable'
      className={classes.table}
      firstColumn={firstColumn}
      columns={columns}
      rows={students}
      rowKey={(student) => student.id}
    />
  )
}

InvitedTable.propTypes = {
  students: PropTypes.array,
  onResendInvite: PropTypes.func,
}

export default InvitedTable
